export default {"src":"/_next/static/media/FLEX.afdc1161.svg","height":18,"width":18};